export const formatDateTimeForAPI = (date: Date | null) => {
  if (!date) return null;
  return date.toISOString();
};
